import { alertFilterModelManipulator } from './filter/model.manipulator';
import { AlertSeverityThresholdModel } from './alert-severity-threshold';
class AlertModelManipulator {
    getElasticFilters = (elasticFilters) => {
        if (!(elasticFilters.bool && elasticFilters.bool.filter))
            return [];
        return elasticFilters.bool.filter
            .map(filter => alertFilterModelManipulator.convertElasticToFilter(filter))
            .filter(filter => Boolean(filter));
    };
    getMustElasticFilters = (elasticFilters) => {
        if (!(elasticFilters.bool && elasticFilters.bool.must))
            return [];
        return elasticFilters.bool.must
            .map(filter => alertFilterModelManipulator.convertElasticToFilter(filter))
            .filter(filter => Boolean(filter));
    };
    getMustNotElasticFilters = (elasticFilters) => {
        if (!elasticFilters.bool || !(elasticFilters.bool && elasticFilters.bool.must_not))
            return [];
        return elasticFilters.bool.must_not
            .map(filter => alertFilterModelManipulator.convertElasticToFilter(filter, true))
            .filter(filter => Boolean(filter));
    };
    convertElasticToFilters(elasticFilters) {
        if (!elasticFilters)
            return [];
        return [
            ...this.getElasticFilters(elasticFilters),
            ...this.getMustElasticFilters(elasticFilters),
            ...this.getMustNotElasticFilters(elasticFilters),
        ];
    }
    convertFiltersToElastic(alertQueryDefinition) {
        if (alertQueryDefinition.filters.length === 0)
            return { bool: {} };
        return {
            bool: {
                must: alertQueryDefinition.filters
                    .filter(filter => !filter.negate)
                    .map(filter => alertFilterModelManipulator.convertToElastic(filter)),
                must_not: alertQueryDefinition.filters
                    .filter(filter => filter.negate)
                    .map(filter => alertFilterModelManipulator.convertToElastic(filter)),
            },
        };
    }
    convertSeverityThresholdTiersToRecord(severityThresholdTiers) {
        const severitiesRecord = {};
        severityThresholdTiers.forEach(({ severityLevel, threshold }) => (severitiesRecord[severityLevel] = threshold));
        return severitiesRecord;
    }
    convertRiskScoreTiersToRecord(severityThresholdTiers) {
        const riskScoreRecord = severityThresholdTiers.reduce((record, { severityLevel, riskScore }) => typeof riskScore === 'number' ? Object.assign(record, { [severityLevel]: riskScore }) : record, {});
        return Object.keys(riskScoreRecord).length === 0 ? undefined : riskScoreRecord;
    }
    convertSeverityThresholdTiersToArray(severityThresholdTiers, riskScoreTiers) {
        return Object.entries(severityThresholdTiers).map(([severityLevel, threshold]) => {
            const severityThreshold = new AlertSeverityThresholdModel();
            severityThreshold.severityLevel = severityLevel;
            severityThreshold.threshold = threshold;
            severityThreshold.riskScore = riskScoreTiers?.[severityLevel];
            return severityThreshold;
        });
    }
    applyDuplicateProps(alert) {
        return {
            title: `Copy of ${alert.title}`,
            ...(alert.uid && { uid: null }), // Keep UID if it exists, for Grafana alerts
            id: undefined,
            createdBy: null,
            updatedBy: null,
        };
    }
    getGroupByFieldName({ alert, subComponentIndex, groupByIndex, }) {
        return alert.subComponents[subComponentIndex].queryDefinition.groupBy[groupByIndex].name;
    }
    getMaxJoinsAmount(alert) {
        return Math.min(...alert.subComponents.map(({ queryDefinition: { groupBy } }) => groupBy.length));
    }
}
export const alertModelManipulator = new AlertModelManipulator();
//# sourceMappingURL=alert.manipulator.js.map